var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0257 4.65137H4.02525C3.0465 4.65137 2.25 5.44787 2.25 6.42662V18.4266C2.25 19.4054 3.0465 20.2011 4.02525 20.2011H20.025C21.0037 20.2011 21.7995 19.4046 21.7995 18.4266V6.42662C21.8002 5.44787 21.0037 4.65137 20.0257 4.65137ZM3.80025 6.20162H20.25V7.04762L20.163 7.11512L12.0247 13.4459L11.886 13.3371L3.80025 7.04837V6.20162ZM3.80025 18.6516V9.01037L11.55 15.0381C11.82 15.2504 12.2317 15.2504 12.5002 15.0381L12.5317 15.0141L20.25 9.01037L20.2523 18.6516H3.80025Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsEnvelope);
export default __webpack_public_path__ + "static/media/icons-envelope.1f41473f45a6925ea0d8666ea3d8987c.svg";
export { ForwardRef as ReactComponent };